module.exports = __webpack_public_path__ + "static/img/banner-18-sept-jerman.50d3b19.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/banners/banner-18-sept-jerman.png
// module id = xYp7
// module chunks = 1